import React, { PropsWithChildren } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import SubscriptionPricing from 'components/SubscriptionPricing'
import useWindowSize from 'components/util/useWindowSize'
import imageResize, { generateSrcSet } from 'project/image-proxy-web'
import FeatureItem from 'components/FeatureItem'
const features = [
  {
    description:
      'In 2022 alone, the UK saw the formation of 805,141 new companies, indicating a thriving entrepreneurial landscape.',
    title: 'Growing market.',
  },
  {
    description:
      'Our mail handling and digital document management solution makes digitisation available to even the smallest client and business. Removes the complexity of physical mail handling.',
    title: 'Digitisation.',
  },
  {
    description:
      'Our partners are seeing an average 46% year-on-year growth over the past three years.',
    title: 'Experience growth.',
  },
  {
    description:
      'For one of our clients, their customer base of 10K clients generate an additional £400,000 per year with our registered office address solution.',
    title: 'Revenue stream.',
  },
]

type TargetMarketAndGrowthType = {
  className?: string
}

const TargetMarketAndGrowth: ReactFC<
  PropsWithChildren<TargetMarketAndGrowthType>
> = ({ className = '' }) => {
  return (
    <div className={`card`}>
      <div className='row px-2 px-lg-0'>
        <div className='col-12 mt-0 pt-8 pt-lg-11 g-3 g-lg-4 col-lg-6'>
          <div className='ps-4 ps-lg-20 pb-5 pb-lg-17 pe-4 pe-lg-0'>
            <h3 className='fs-fluid-36-80 fw-semibold mb-3 mb-lg-6 lh-105'>
              Target Market & Growth Potential.
            </h3>

            <div className='d-flex flex-column gap-5 fs-fluid-16-20'>
              {features.map((feature) => (
                <FeatureItem
                  key={feature.title}
                  title={feature.title}
                  description={feature.description}
                />
              ))}
            </div>
          </div>
        </div>

        <div className='col-12 mt-0 col-lg-6 d-flex flex-column position-relative'>
          <img
            {...generateSrcSet('/images/new/robot-mail-preview.png', 678, 820)}
            alt='HaiRo™ mail service with robot mascot and phone displaying mail interface'
            className='rounded-img position-absolute w-100 object-fit-contain'
            height={820}
            width={678}
            style={{
              maxHeight: '100%',
              objectPosition: 'right ',
              right: 0,
              top: 0,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default TargetMarketAndGrowth
